import { API } from '@/models/core'

export class CricketTeam {
  static fetchProfile (key, isMetric) {
    let url
    if (isMetric) {
      url = `/cricket/v4/team/${key}/`
    } else {
      url = `/cricket/team/${key}/`
    }
    return API.instance().get(url).then((resp) => {
      const raw = resp.data.data
      const team = CricketTeam.createFromJson(raw.team.key, raw.team)
      return team
    })
  }

  static createFromJson (key, raw) {
    let team = new CricketTeam()
    team = Object.assign(team, raw)
    team.key = key
    return team
  }
}

CricketTeam.State = {
  selected: null
}
